import log from "loglevel";

export const getDomainName = () => {
  const origin = window.location.origin;
  log.info(`Current Domain Name: ${origin}`);
  return origin;
};

export const getFullUrl = () => {
  const fullUrl = window.location.href;
  log.info(`Current URL: ${fullUrl}`);
  return fullUrl;
};
